import axios from 'axios'

const api = axios.create({
  baseURL: '/api',
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('sat_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  (response) => {
    const newToken = response.headers['x-new-token']
    if (newToken) {
      localStorage.setItem('sat_token', newToken)
    }
    return response
  },
  (error) => {
    const url: string = error.config?.url || ''
    // Don't hijack the login request itself; LoginPage handles its own 401/409.
    const isLoginRequest = url.includes('/auth/login')
    // Logout must be allowed to fail silently — redirecting here would race
    // with AuthContext.logout and leave the tbl_user_session row orphaned.
    const isLogoutRequest = url.includes('/auth/logout')

    if (error.response?.status === 401 && !isLoginRequest && !isLogoutRequest) {
      const sessionRevoked =
        error.response?.headers?.['x-session-revoked'] === 'true'
      localStorage.removeItem('sat_token')

      if (sessionRevoked && window.location.pathname !== '/login') {
        const msg = encodeURIComponent(
          error.response?.data?.detail ||
            'Your session was ended because this account signed in from another location.',
        )
        window.location.href = `/login?reason=session-revoked&message=${msg}`
      } else if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }
    if (error.response?.status === 402 && !isLogoutRequest) {
      const path = window.location.pathname
      const noRedirect = path === '/payment' || path === '/subscription' || path === '/dashboard'
      if (!noRedirect) {
        const detail = encodeURIComponent(
          error.response?.data?.detail || 'Your subscription expired'
        )
        const reason = error.response?.headers?.['x-trial-expired']
          ? 'trial-expired'
          : 'subscription-expired'
        window.location.href = `/payment?reason=${reason}&message=${detail}`
      }
    }
    return Promise.reject(error)
  }
)

export default api
